import { useCordAnnotationCaptureHandler, useCordAnnotationClickHandler, useCordAnnotationRenderer, useCordAnnotationTargetRef, } from '@cord-sdk/react';
import _ from 'lodash';
import React from 'react';
import { CordContextInformer } from './wrap-cord-provider';
import { pinCordinates } from './wrap-cord-utlis';
const BaseWrapAsCordComponent = ({ location, extraLocation = {}, label = '', annotationRef, cordAnnotationCaptureHandler, cordAnnotationRendererHandler, cordAnnotationClickHandler, className, children, pinAlignment = 'middle', }) => {
    let annotationTargetRef = useCordAnnotationTargetRef(location);
    if (!_.isNil(annotationRef)) {
        annotationTargetRef = annotationRef;
    }
    let annotationCapturerHandler = cordAnnotationCaptureHandler;
    if (_.isNil(cordAnnotationCaptureHandler)) {
        // Anyone using this component should implement this if they have a
        // dynamic way to get location
        // For Eg in Charts We are finding nearest point where annotation is clicked
        // if extraLocation and label is not defined below will be the default
        annotationCapturerHandler = () => {
            return {
                extraLocation,
                label,
            };
        };
    }
    useCordAnnotationCaptureHandler(location, annotationCapturerHandler);
    // Annotation Renderer Handler
    let annotationRendererHandler = cordAnnotationRendererHandler;
    if (_.isNil(cordAnnotationRendererHandler)) {
        // This is used to provide which element we are going to add annotation
        // on. By default we chose to annotate on complete container itself
        // on the top of container
        // Please provide your own implementation if you need to tag it.
        // if element and coordinates are not defined below will be the default
        annotationRendererHandler = () => {
            return {
                element: annotationTargetRef.current,
                coordinates: pinCordinates[pinAlignment],
            };
        };
    }
    // Annotation Renderer Handler
    useCordAnnotationRenderer(location, annotationRendererHandler);
    let annotationClickHandler = cordAnnotationClickHandler;
    if (_.isNil(cordAnnotationClickHandler)) {
        annotationClickHandler = () => {
            if (annotationTargetRef === null || annotationTargetRef === void 0 ? void 0 : annotationTargetRef.current) {
                // SCAL-159108 Disabling red highlight
                // const existingStyle =
                //     annotationTargetRef?.current.getAttribute('style') ?? '';
                // annotationTargetRef?.current.setAttribute(
                //     'style',
                //     'border: 2px solid red',
                // );
                // setTimeout(() => {
                //     annotationTargetRef?.current?.setAttribute(
                //         'style',
                //         existingStyle,
                //     );
                // }, 1000);
                annotationTargetRef === null || annotationTargetRef === void 0 ? void 0 : annotationTargetRef.current.scrollIntoView({
                    block: 'center',
                    inline: 'start',
                });
            }
        };
    }
    // What happens when we click the annotation is handled by this hook.
    useCordAnnotationClickHandler(location, annotationClickHandler);
    return (React.createElement("div", { className: className, "data-testid": "cord-component", "data-cord-annotation-allowed": "true", ref: annotationTargetRef }, children));
};
/**
 * Simple Wrapper to make any component to be tagged in cord environment
 *
 *
 * Also make sure this wrapper should be present in only one MFE app
 */
export const WrapAsCordComponent = ({ enableAnnotation = true, location, extraLocation = {}, label = '', annotationRef, cordAnnotationCaptureHandler, cordAnnotationRendererHandler, cordAnnotationClickHandler, className, children, pinAlignment, }) => {
    const isWrappedWithCordProvider = React.useContext(CordContextInformer);
    if (!enableAnnotation || !isWrappedWithCordProvider) {
        // Added specifically when we do not want to annotate
        // conditionally
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement(BaseWrapAsCordComponent, { location: location, extraLocation: extraLocation, label: label, annotationRef: annotationRef, className: className, cordAnnotationCaptureHandler: cordAnnotationCaptureHandler, cordAnnotationRendererHandler: cordAnnotationRendererHandler, cordAnnotationClickHandler: cordAnnotationClickHandler, pinAlignment: pinAlignment }, children));
};
//# sourceMappingURL=wrap-cord-component.js.map